<template>
  <div
    class="questionnaire-container"
    :key="key"
    :style="`margin-left: ${first ? '0' : '20'}px;`"
  >
    <div class="question-input-container">
      <el-input
        v-model="questionnaire.question"
        size="small"
        :class="`question-input${first ? ' first' : ''}`"
      >
        <template slot="prepend">
          Kérdés
        </template>
      </el-input>
      <el-button
        icon="el-icon-remove"
        size="small"
        type="danger"
        @click="deleteQuestion"
        v-if="!first"
      >
        Törlés
      </el-button>
    </div>
    <div>
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        :class="`add-question-button${first ? ' first' : ''}`"
        @click="addAnswer"
      >
        Válasz hozzáadása
      </el-button>
    </div>
    <ul class="questions-list">
      <li
        v-for="(answer, index) in questionnaire.answers"
        class="answer-list-element"
      >
        <div class="answer-input-container">
          <el-input
            v-model="answer.answer"
            size="small"
          >
            <template slot="prepend">
              Válasz
            </template>
          </el-input>
          <el-button
            icon="el-icon-remove"
            size="small"
            type="danger"
            @click="deleteAnswer(questionnaire, index)"
          >
            Törlés
          </el-button>
        </div>
        <div class="new-question-container">
          <el-button
            v-if="!answer.question"
            type="success"
            icon="el-icon-plus"
            size="mini"
            @click="addQuestion(index)"
          >
            Kérdés hozzáadása
          </el-button>
        </div>
        <questionnaire
          v-if="answer.question"
          :question="answer.question"
          @deleteQuestion="onDelete(answer)"
          ref="questionnaire"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Questionnaire',
  props: ['question', 'first'],
  data() {
    return {
      questionnaire: {},
      key: 0,
    };
  },
  mounted() {
    this.questionnaire = this.question;
  },
  methods: {
    onRerender() {
      this.key++;
    },
    onDelete(answer) {
      delete answer.question;
      this.key++;
    },
    deleteQuestion() {
      this.$emit('deleteQuestion');
    },
    deleteAnswer(questionnaire, index) {
      questionnaire.answers.splice(index, 1);
    },
    addAnswer() {
      this.questionnaire.answers.push({ key: Math.random().toString(36).substring(7), answer: '' });
    },
    addQuestion(index) {
      this.questionnaire.answers[index].question = {
        key: Math.random().toString(36).substring(7),
        question: '',
        answers: []
      };
      this.key++;
    },
  },
};
</script>

<style lang="scss">
  .questionnaire-container {
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 10px;
  }
  .question-input-container {
    display: flex;

    > .el-button {
      margin-left: 10px;
    }
  }

  .question-input {
    &.first {
      margin-left: 0;
    }
    /*margin-left: 20px;*/
  }

  .add-question-button {
    margin-top: 10px;
    &.first {
      margin-left: 0;
    }
    margin-left: 20px;
  }

  ul.questions-list {
    padding-left: 20px;
    li.answer-list-element {
      list-style: none;
      margin-top: 10px;

      > .answer-input-container {
        display: flex;

        > .el-button {
          margin-left: 10px;
        }
      }
      > .new-question-container {
        margin-top: 10px;
        > .el-button {
          margin-left: 20px;
        }
      }
    }
  }
</style>
